import pdfToText from "react-pdftotext";
import { parseCbsReportText } from "./parseCbsReportText";

export const parseCbsReportFromPdf = async (fileUrl) => {
  if (!fileUrl) return null;
  const response = await fetch(fileUrl);
  if (!response.ok) {
    throw new Error("Unable to download CBS report.");
  }
  const blob = await response.blob();
  const file = new File([blob], "cbs-report.pdf", {
    type: blob.type || "application/pdf",
  });
  const creditFile = await pdfToText(file);
  return parseCbsReportText(creditFile);
};
